import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, resolveImg } from "@/lib/api";
import { useLang } from "@/context/LangContext";
import { useSeo } from "@/lib/useSeo";
import { Skeleton } from "@/components/ui/skeleton";
import { CalendarDays, MapPin } from "lucide-react";

export default function Guides() {
  const { t, pick } = useLang();
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/guides").then((r) => setRows(r.data)); }, []);
  useSeo({ title: t("guides_title"), description: t("guides_sub") });

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <div className="mb-8">
        <div className="text-xs uppercase tracking-widest text-gold-dark">{t("browse")}</div>
        <h1 data-testid="guides-heading" className="font-display text-3xl md:text-4xl font-bold text-indigo-deep">{t("guides_title")}</h1>
        <p className="text-sm md:text-base text-indigo-deep/60 mt-1">{t("guides_sub")}</p>
      </div>
      {!rows ? (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">{["a", "b", "c"].map((k) => <Skeleton key={k} className="h-72 rounded-xl" />)}</div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="guides-grid">
          {rows.map((g) => (
            <Link key={g.id} to={`/guides/${g.slug}`} data-testid={`guide-card-${g.slug}`} className="group bg-white rounded-xl overflow-hidden border border-gold/15 card-shadow hover:-translate-y-1 transition-transform duration-300">
              <div className="aspect-[16/10] overflow-hidden bg-indigo-deep">
                <img src={resolveImg(g.image)} alt={pick(g, "title")} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-1 text-[11px] uppercase tracking-wider text-gold-dark"><MapPin className="w-3 h-3" />{g.state || g.dham}</div>
                <h2 className="font-display text-lg text-indigo-deep mt-1 leading-snug">{pick(g, "title")}</h2>
                <p className="text-sm text-indigo-deep/65 mt-1 line-clamp-2">{pick(g, "summary")}</p>
                <div className="flex items-start gap-1.5 text-xs text-indigo-deep/60 mt-3"><CalendarDays className="w-3.5 h-3.5 mt-0.5 text-gold-dark shrink-0" /><span className="line-clamp-1">{pick(g, "best_time")}</span></div>
                <div className="text-sm font-semibold text-gold-dark mt-3">{t("read_guide")}</div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
